import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Logout from '../../components/Logout/Logout';
import paths from '../../constants/paths';
import { resetAccountStatus } from '../../store/actions/resetAccountStatus';
import { resetPaymentData } from '../../store/actions/paymentData';
import { openAd } from '../../assets/helpers/serveAd';

class LogoutContainer extends Component {
  state = {
    ads: []
  };
  UNSAFE_componentWillMount () {
    if (this.props.logoutAds.length > 0) {
      this.setState({ads: this.props.logoutAds});
    }
  }
  componentWillUnmount () {
    this.props.resetAccountStatus();
    this.props.resetPaymentData();
  }
  goToIndex = () => {
    this.props.resetAccountStatus();
    this.props.resetPaymentData();
    this.props.history.replace(paths.INDEX);
  }
  onAdClick = (ad) => {
    openAd(ad);
  }
  render () {
    // console.log('LogoutContainer Render', this.props);
    return <Logout goToIndex={this.goToIndex} isLandscape={this.props.isLandscape} ads={this.state.ads} onAdClick={this.onAdClick} />;
  }
}
function mapStateToProps (state) {
  return {
    session: state.session,
    logoutAds: state.checkAccountStatus.logoutAds
  };
}
function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    resetAccountStatus,
    resetPaymentData
  }, dispatch);
}
// export default (LogoutContainer);
export default connect(mapStateToProps, mapDispatchToProps)(LogoutContainer);



// WEBPACK FOOTER //
// ./src/containers/Logout/Logout.js